// Vision / Mission / Values / 代表メッセージの対外確定表記の正本。
// Home / About / Careers はすべてここから参照する（各ページにハードコードしない）。
// 出典: 採用_会社紹介資料 v0.2、営業_会社とサービスのご紹介 v0.1（いずれも2026年10月）。

// 会社の一行紹介（Homeヒーロー / Aboutイントロで共用）
export const tagline = 'AIをつくる力と、企業の仕事に届ける力。その両方を持つ。';

// taglineの補足（何をする会社かを一文で）
export const descriptor =
  'AIに関わる会社は多くあります。SALT2は自ら製品と技術をつくり、企業の仕事の成果が出るところまで担います。';

export const vision = {
  // 表示用の行割り（MaskedLines に渡す）
  enLines: ['ADVANCE', 'HUMAN', 'HISTORY'],
  jp: '人類史を前進させる。',
  // ホームの Vision & Mission の帯の見出し（語単位でアニメーションさせる分割。英語の大見出しは出さない）
  jpLinesSplit: [['人類史を', '前進させる。']],
  // ビジョンの意味。出典: SALT2-business-strategy 会社構想 README §1・経営_会社のVisionとMission §1
  // （2026-09 までの鬼澤の説明をまとめたもの）。2026-10-18 代表指示でホームも会社概要と同じ Vision & Mission の帯に
  // したため、いまは画面に出していない。
  lead: 'AIが人の仕事を担い、人と社会が実現できることを増やす。',
  body: [
    '新しい技術によって、これまで難しかったことができるようになる。人がより多くのものを生み出し、未知の領域へ挑戦できるようになる。SALT2は、その変化を自分たちの仕事によって進めたい。',
    'AIが人の仕事を担えば、人間とAIを合わせた社会全体のアウトプットは増える。人は、なお人が担う仕事や、これまで手が届かなかった挑戦に向かえる。',
    '日本の企業でAIを実装することは、このビジョンを実行する場所であり、その先に人類全体の前進を見ている。',
  ],
};

export const mission = {
  // 一文で使うとき（リード文など）
  jp: 'AI時代に、社会へのインパクトを最大化する。',
  // 2行で見出し表示するとき（About / Careers）
  jpLines: [['AI時代に、社会への'], ['インパクトを最大化する。']],
  // Homeヒーロー用（語単位でアニメーションさせる分割）
  jpLinesSplit: [
    ['AI時代に、', '社会への'],
    ['インパクトを', '最大化する。'],
  ],
  // 本文の見出し（OUR MISSION）
  lead: 'AIの進化を、一人ひとりのインパクトに変える。',
  // 本文（段落ごと）
  body: [
    'AIは、これからも進化し続ける。それが社会を大きく変えていくことは、もう前提になった。',
    '問われるのは、その力を使って、自分が社会にどれだけのインパクトを与えられるか。',
    'SALT2は、一人ひとりが出せるインパクトを最大にする。その総和で、会社として社会へのインパクトを最大化する。',
  ],
};

// Valuesセクションのリード文
export const valuesLead = 'Missionを実現するために、一人ひとりが毎日自分に問う基準。';

// 代表メッセージ
export const ceoMessage = {
  titleLines: [['「社会を大きく変えられるかもしれない」'], ['その興奮の、最前線へ。']],
  body: [
    'AIが本格的にビジネスの現場に入り始めた今、この領域には、かつてないほどの興奮があります。',
    '技術の進化は速く、半年前の常識がすぐに塗り替わる。最前線で挑戦し続けながら事業のインパクトを追求できるこのタイミングは、本気で燃えたい人にとって、最高に刺激的です。',
    'この数年は、人類史でも稀な変化の入口だと本気で思っています。経歴は問いません。最高の仲間と共に猛烈に走り、人生の勝負所に飛び込み、勝ち切りましょう。',
  ],
  name: '鬼澤 輔',
  role: '代表取締役',
  image: '/profile/onizawa.png',
};

export { values } from './values';
